import { motion } from 'framer-motion'
import { Users, Briefcase, GitMerge } from 'lucide-react'

const audiences = [
  {
    Icon: Users,
    title: 'QA leads',
    body: 'Triage failures across 50 test runs in one prompt. Stop tab-hopping between Jira, GitHub, and your test dashboard.',
    color: 'from-cyan-500 to-sky-500',
  },
  {
    Icon: Briefcase,
    title: 'Engineering managers',
    body: 'Get sprint-level pass-rate trends, regression hotspots, and release-blocker reports without writing a single SQL query.',
    color: 'from-sky-500 to-blue-500',
  },
  {
    Icon: GitMerge,
    title: 'TestOps + DevOps',
    body: 'Wire CI/CD events into the chat. File bugs, rerun suites, post to Slack — the same prompt language you use to investigate.',
    color: 'from-teal-500 to-cyan-600',
  },
]

export function BuiltForTeams() {
  return (
    <section className="relative bg-gradient-to-b from-zinc-950 to-black py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
          className="mx-auto max-w-2xl text-center"
        >
          <p className="font-mono text-xs uppercase tracking-widest text-cyan-400">
            // built for
          </p>
          <h2 className="mt-4 text-4xl font-bold tracking-tight text-white sm:text-5xl">
            One command center. Three jobs.
          </h2>
        </motion.div>

        <div className="mx-auto mt-16 grid max-w-5xl grid-cols-1 gap-6 md:grid-cols-3">
          {audiences.map((a, i) => (
            <motion.div
              key={a.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.02] p-8 transition hover:border-white/20 hover:bg-white/[0.05]"
            >
              <div
                className={`mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br ${a.color} shadow-lg`}
              >
                <a.Icon className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-white">{a.title}</h3>
              <p className="mt-3 leading-relaxed text-white/70">{a.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
